import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'scientific_work_type', label: 'Scientific work type', sortable: true },
    { key: 'scientific_work_name', label: 'Scientific work name', sortable: true },
    { key: 'publication_date', label: 'Publication date', sortable: true },
    { key: 'scientific_work_url', label: 'Scientific work url', sortable: true },
    { key: 'scientific_work', label: 'Scientific work', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('scientificWork'),
  }
}
